import { Component, inject } from '@angular/core';
import { StateService } from '../../../services/state.service';
import { AuthorizationService } from '../../../services/authorization.service';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-empty-campaigns-banner',
  imports: [AssetVersionPipe],
  templateUrl: './empty-campaigns-banner.component.html',
  styleUrl: './empty-campaigns-banner.component.scss'
})
export class EmptyCampaignsBannerComponent {
  private authorizationService = inject(AuthorizationService);
  public onClick(): void {
    window.open(`https://info.browsi.com/-request-to-connect-creative-wrapper?email=${this.authorizationService.userProfile.email}`, '_blank');
  }
}
